module.exports = __webpack_public_path__ + "img/icon-close.896d5b2b.svg";